import React from 'react';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';

interface ViewControlGroupProps {
  children?: React.ReactNode;
  type?: string;
  role?: string;
}

const ViewControlGroup: React.FC<ViewControlGroupProps> = ({ children, role, type = '' }) => (
  <div className={getSuitCSSClasses({ namespace: 'hz', name: 'ViewControl-group', modifiers: [type] })} role={role}>
    {children}
  </div>
);

export default ViewControlGroup;
